import React from 'react';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Radio, Button, Modal, Form, Row, Col, Icon, Input, Select, DatePicker, Spin, Popconfirm } from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { handleSearch, getTaskInfos, getExportUrl, sendMail } from './action';
import { connect } from 'react-redux';
import { trunRangePicker } from './constant';
import moment from 'moment';
import './styles.css';

class StatisticView extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
    }

    componentDidMount() {
        this.props.getTaskInfos(); //查询任务统计的echarts数据
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.handleSearch(Object.assign(_obj, { 'sBeginTime': moment().format('YYYY-MM-DD'), 'sEndTime': moment().format('YYYY-MM-DD') }));
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'filtration') {
                _obj['time'] = undefined;              //互斥显示
                _obj['filtration'] = fields[key].value;//互斥显示
                _obj['sBeginTime'] = moment(fields[key].value[0]).format('YYYY-MM-DD');
                _obj['sEndTime'] = moment(fields[key].value[1]).format('YYYY-MM-DD');
            } else {
                _obj['time'] = fields[key].value;//互斥显示
                _obj['filtration'] = undefined;  //互斥显示
                switch (fields[key].value) {
                    case '1'://今日
                        _obj['sBeginTime'] = moment().format('YYYY-MM-DD');
                        _obj['sEndTime'] = moment().format('YYYY-MM-DD');
                        break;
                    case '2'://昨日
                        _obj['sBeginTime'] = moment().subtract(1, 'days').format('YYYY-MM-DD');
                        _obj['sEndTime'] = moment().subtract(1, 'days').format('YYYY-MM-DD');
                        break;
                }
            }
        });
        this.props.handleSearch(Object.assign(_obj));
        this.props.getExportUrl();
        this.fieldsOnChangeImpl(fields);
    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => {
            if (key === 'time') {
                this.props.getTaskInfos();
            }
        });
    }


    render() {
        const { loading, taskInfos } = this.props;
        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                    <table border="1px" className="gridtable" cellSpacing="0" cellPadding="0">
                        <tr>
                            <th>类型</th>
                            <th>订单名称</th>
                            <th>产品名称</th>
                            <th>营运量</th>
                        </tr>
                        {
                            Object.keys(taskInfos).map((taskType, taskTypeIndex) => {
                                let taskNames = taskInfos[taskType];
                                return Object.keys(taskNames).map((taskName, taskNameIndex, array) => {
                                    let list = taskNames[taskName];
                                    return list.map((task, index, tasks) => {
                                        return (<tr>
                                            {taskType === "EV" ? <td>曝光</td> : <td>点击</td>}
                                            {index === 0 ? <td rowSpan={tasks.length}>{task.taskDescription}</td> : ""}
                                            <td>{task.taskName}</td>
                                            <td>{task.targetPv}</td>
                                        </tr>);
                                    });
                                })
                            })
                        }
                    </table >
                </Spin >
            </div >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.statisticsView.loading,
    search: state.statisticsView.search,
    taskInfos: state.statisticsView.taskInfos,
    exportUrl: state.statisticsView.url,
});

const mapDispatchToProps = dispatch => ({
    handleSearch: search => dispatch(handleSearch(search)),
    getTaskInfos: () => dispatch(getTaskInfos()),
    getExportUrl: () => dispatch(getExportUrl()),
    sendMail: (type) => dispatch(sendMail(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatisticView);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
        this.sendMail10 = this.sendMail10.bind(this);
        this.sendMail18 = this.sendMail18.bind(this);
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getTaskInfos();
    }

    sendMail10() {
        this.props.sendMail('10');
    }
    sendMail18() {
        this.props.sendMail('18');
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>结算统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={4}>
                            <FormItem>
                                {getFieldDecorator('time', {
                                    initialValue: '1'
                                })(<RadioGroup>
                                    <RadioButton value="1">今日</RadioButton>
                                    <RadioButton value="2">昨日</RadioButton>
                                </RadioGroup>)}
                            </FormItem>
                        </Col>
                        <Col span={9}>
                            <FormItem>
                                {getFieldDecorator('filtration')(
                                    <RangePicker />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={10} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                            <Button style={{ marginLeft: 8 }} >
                                <a href={this.props.exportUrl} download="filename">导出</a>
                            </Button>
                            <Popconfirm title="是否进行此操作" onConfirm={this.sendMail10}>
                                <Button style={{ marginLeft: 8 }} >
                                    10点邮件
                                </Button>
                            </Popconfirm>
                            <Popconfirm title="是否进行此操作" onConfirm={this.sendMail18}>
                                <Button style={{ marginLeft: 8 }} >
                                    18点邮件
                                </Button>
                            </Popconfirm>
                        </Col>

                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            time: {
                value: props.search.time
            },
            filtration: {
                value: props.search.filtration
            },
        }
    }
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/statistics-view/index.js